module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Management_01-0dc987cbfbc6519884812cb2337f3fb9.jpg";